import { Badge } from '@chakra-ui/react'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'

import { Check, Close } from '@/icons'

export const ValidityBadge = ({ valid, showValid }: { valid?: boolean, showValid?: boolean }) =>
  !valid ? (
    <CustomTooltip trigger="clickHover" label="Neaktivní" hasArrow>
      <Badge colorScheme="red" display="flex" alignItems="center" h="20px">
        <Close boxSize={4} />
      </Badge>
    </CustomTooltip>
  ) : showValid && (
    <CustomTooltip trigger="clickHover" label="Aktivní" hasArrow>
      <Badge colorScheme="green" display="flex" alignItems="center" h="20px">
        <Check boxSize={4} />
      </Badge>
    </CustomTooltip>
  )
